<template>
  <div class="journey-tabs">
    <v-tabs
      :value="value === 'AM' ? 0 : 1"
      :color="color"
      :disabled="disabled"
      height="24"
      :class="
        `journey-tabs__container ${
          disabled ? 'journey-tabs__container--disabled' : ''
        }`
      "
      @change="onTabChange"
    >
      <v-tabs-slider></v-tabs-slider>
      <v-tab
        v-for="item in items"
        :key="item"
        :value="item"
        class="journey-tabs__tab"
      >
        {{ item }}
      </v-tab>
    </v-tabs>
  </div>
</template>

<script>
export default {
  name: 'JourneyTabs',
  props: {
    items: {
      type: Array,
      required: true,
      validator: items => items.every(item => typeof item === 'string'),
    },
    value: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'accent',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input'],
  methods: {
    onTabChange(newValue) {
      // Convert index to actual item value
      const actualValue = this.items[newValue]
      this.$emit('input', actualValue)
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.journey-tabs {
  max-width: 65px;
  height: 24px;

  &__container {
    &--disabled {
      pointer-events: none;
    }
    &.v-tabs {
      background: $bh-blue--4;
      border-radius: 9999px;
      height: 24px;
      min-height: 24px;

      .v-tabs-slider-wrapper {
        display: none !important;
      }

      .v-slide-group__wrapper {
        border-radius: 999px;
      }

      & > .v-tabs-bar {
        height: 24px;
        min-height: 24px;

        .v-tab {
          transition-duration: 500ms !important;
          transition-property: color;
          text-transform: none;
          letter-spacing: 0;
          font-size: 12px;
          font-weight: 700;
          height: 24px;
          min-height: 24px;
          padding: 0 4px !important;
          margin: 0 2px;

          &:not(.v-tab--active) {
            color: $bh-black;
          }

          &--active {
            color: $bh-white;

            &::before {
              background-color: $bh-blue;
              opacity: 1;
              border-radius: 24px;
              z-index: -1;
              height: 16px;
              width: 27px;
              transform: translateY(-50%);
              top: 50%;
              left: 50%;
              margin-left: -13.5px;
            }
          }
        }
      }
    }
  }

  &__tab {
    min-width: 20px !important;
    width: auto !important;
  }
}
</style>
